import React, {useEffect, useRef, useState} from 'react';


import './SettingsControls.scss'

import SettingsControlsMenu from './menu/SettingsControlsMenu'

import GuiThemesPopup from './guiThemes/GuiThemesPopup'


import {CheckoutSettingPopup} from "./checkoutSettingsPopup/checkoutSettingPopup";
import {SaleTypesSettings} from "./saleTypesSettings/saleTypesSettings";
import {AccountLocalAndTextSettingModal} from "./accountLocalAndTextSettings/accountLocalAndTextSettingModal";
import {Box, Button, Popover, Typography} from "@mui/material";
import {ReactComponent as SettingIcon} from "./../../../../../../assets/setting_icon.svg";
import {ReactComponent as AnalyticsIcon} from "./../../../../../../assets/analytics_icon.svg";
import {AnalyticsPopup} from "../../../../../../com/analyticsPopup/analyticsPopup";
import {useTypedSelector} from "../../../../../../hooks/useTypeSelector";
import {makeStyles} from "@mui/styles";
import styles from "../../../../promos/FlyerPromosEditor.module.scss";
import {PageSpinner} from "../../../../../com/pagesTab/pagesSpinner/spinner";
import {FlyerClassesPopup} from "./flyerClassesPopup/flyerClassesPopup";
import AccountEmailSettingPopup from "./emailsSettingsPopup/accountEmailSettingPopup";
import StoreSettingsPopup from "./storeSettingsPopup/storeSettingsPopup";
import envManager from "../../../../../../com/envManager/EnvManager";
import {FlyerLanguageDto, ItemsListMenuDto, PopupSettings, UserDto} from "../../../../../../dtos";
import {ClickMenu} from "../../../../../../com/clickMenu/clickMenu";
import {ReactComponent as PlusIcon} from "../../../../../../assets/promos&items/icon_plus.svg";
import {MENU_LIST_STORE_ITEMS} from "../../../../../../globals/Contants";
import {
    addEventDataTypeListener,
    EVENT_DATA_TYPE_UPLOAD_FILE_FOR_STORE_TYPE,
} from "../../../../../../globals/EventDispatcher";
import {CustomDataEvent} from "../../../../../../globals/CustomDataEvent";
import {useDispatch} from "react-redux";
import {
    getEmptyFileForStore,
    uploadDeletionItemsExcelFileForStore,
    uploadItemsExcelFileForStore,
    uploadItemsExcelFileWithImagesForStore
} from "../../../../../../store/actionCreators/storeForAccountActionCreators";
import {ActionType} from "../../../../../../store/actionTypes";
import StatusPopup, {StatusPopupType} from "../../../../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../../../../pages/getSetttingsForPopup";
import UsersAndPermissionPopup from "./usersAndPermissionPopup/usersAndPermissionPopup";

const useStyles = makeStyles(() => ({
    analyticsButton: {
        '&:disabled': {
            opacity: `0.5`
        }
    },
    openStoreBtn: {
        "&.MuiButton-root": {
            padding: `4px 16px`,
            border: `1px solid #FFFFFF`,
            textTransform: `capitalize`,
            background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
            "&:hover": {
                opacity: "0.9"
            },
            "&:disabled": {
                opacity: "0.5"
            }
        }
    }
}))

const SettingsControls: React.FC = () => {
    const dispatch = useDispatch();
    const [showStoreSettingsMenu, setShowStoreSettingsMenu] = useState(false);
    const [showSettingsMenu, setShowSettingsMenu] = useState(false);
    const [showAnalyticsPopup, setShowAnalyticsPopup] = useState(false);

    const [showAccountLocalSettingPopup, setShowAccountLocalSettingPopup] = useState(false)

    const [showGuiThemesPopup, setShowGuiThemesPopup] = useState(false)

    const [showFlyerClassesPopup, setShowFlyerClassesPopup] = useState(false)

    const [showCheckoutSettingsPopup, toggleCheckoutSettingsPopup] = useState(false)
    const [showEmailsSettingsPopup, toggleEmailsSettingsPopup] = useState(false)
    const [showUsersAndPermissionsPopup, toggleUsersAndPermissionsPopup] = useState(false)

    const [showSaleTypesPopup, toggleSaleTypesPopup] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [openMenuForStore, setOpenMenuForStore] = useState<boolean>(false);
    const [selectedItemInMenuForStore, setSelectedItemInMenuForStore] = useState<{ file?: any, code?: string }>({});
    const [popupSettings, setPopupSettings] = useState<PopupSettings>({})
    const [isModalPopup, setModalPopup] = useState<boolean>(false);

    const analyticsData = useTypedSelector((state) => state.analyticsData);
    const flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    const flyersState = useTypedSelector((state) => state.flyers);
    const storeState = useTypedSelector((state) => state.storeForAccount);
    const accountSettingLang = useTypedSelector((state) => state.accountSettingWithLang);
    const accountSetting = accountSettingLang.accountSetting;
    const classes = useStyles();
    const ref = useRef(null);
    const menuRef = useRef(null);
    let userDtoStr = localStorage.getItem('userDto');
    // const isUserViewer = false;
    let isUserViewer = true;
    let isUserEditor = false;
    if(userDtoStr){
        let userDto: UserDto = JSON.parse(userDtoStr);
        isUserViewer = userDto.role !== 2 && userDto.role !== 3;
        isUserEditor = userDto.role === 2;
    }

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);


    useEffect(() => {
        addEventDataTypeListener(EVENT_DATA_TYPE_UPLOAD_FILE_FOR_STORE_TYPE, (data: CustomDataEvent) => {
            setSelectedItemInMenuForStore({
                file: data.data.files[0],
                code: data.data.code
            });
        })
    }, []);

    useEffect(() => {
        const accountLanguage: FlyerLanguageDto | undefined = flyersState?.languageCultures?.find((lang: FlyerLanguageDto) => {
            if (lang.id === accountSettingLang.languageId) {
                return lang;
            }
        })
        switch (selectedItemInMenuForStore.code) {
            case 'UploadItemsForStoreFile':
                dispatch(uploadItemsExcelFileForStore(selectedItemInMenuForStore.file ? selectedItemInMenuForStore.file : {}, accountLanguage?.code));
                break;
            case 'UploadItemImagesForStoreFile':
                dispatch(uploadItemsExcelFileWithImagesForStore(selectedItemInMenuForStore.file ? selectedItemInMenuForStore.file : {}, accountLanguage?.code));
                break;
            case 'ArchiveItemsFromStoreFile':
                dispatch(uploadDeletionItemsExcelFileForStore(selectedItemInMenuForStore.file ? selectedItemInMenuForStore.file : {}, accountLanguage?.code));
                break;
            case 'DownloadEmptyExcelForStoreFile':
                dispatch(getEmptyFileForStore(accountLanguage?.code));
                break;
            // case 'ExportPromosItemsToExcel':
            //     dispatch(getExcelFileWithCurrentDataForPromosAndItemsData(flyerDto.flyRecId!, flyerDto.flyCaption!));
            //     break;
        }
    }, [selectedItemInMenuForStore]);

    useEffect(() => {
        if(storeState.type === ActionType.UPLOAD_STORE_ITEMS_EXCEL_FILE_SUCCESS){
            let message: string[] = [];
            let modalName: string = 'successfullyUpload'
            if (storeState.type === ActionType.UPLOAD_STORE_ITEMS_EXCEL_FILE_SUCCESS) {
                if (storeState.successInfo && storeState.successInfo.severityLevel === 'Info') {
                    message = storeState.successInfo.userFriendlyMessage.split(`\r\n`)
                        .filter(key => key !== '');
                    modalName = `successfullyUploadWithSomePromosAndItemsErrors`;
                    // message.push(`${flippingFlyerState.successInfo.userFriendlyMessage}`);
                } else if(storeState.successInfo && storeState.successInfo.severityLevel === 'OK') {
                    message = storeState.successInfo.userFriendlyMessage.split(`\r\n`)
                        .filter(key => key !== '');
                } else {
                    message.push(`Items have been successfully uploaded`);
                }
            } else {
                message.push(`Item images upload has started, give it a few minutes to complete.`);
            }
            setPopupSettings({
                    typeStatus: 0,
                    title: '',
                    subTitle: '',
                    messages: message,
                    modalName: modalName,
                }
            )
            setModalPopup(true);
        }

    }, [storeState.type])

    useEffect(() => {
        setLoading(analyticsData.loadingExcel ? analyticsData.loadingExcel : false);
    }, [analyticsData.loadingExcel]);

    const handleToggleStoreMenu = () => {
        setOpenMenuForStore((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(openMenuForStore);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const openStore = () => {
        let url ;
        const env = envManager.flyerEditorServerAddress;
        if (env?.includes('dev')) {
            url = envManager.getFlyerAppAddressWithEnvPrefix('dev')
        } else if (env?.includes('qa')) {
            url = envManager.getFlyerAppAddressWithEnvPrefix('qa')
        } else {
            url = envManager.getFlyerAppAddressWithEnvPrefix('')
        }
        let userDtoStr = localStorage.getItem('userDto');
        let userDto: UserDto = JSON.parse(userDtoStr!);

        if (url.length !== 0 && userDto.company) {
            let accountName = userDto.company;
            url += `store/${accountName}`;
            window.open(url, 'urlFromMainScreenForStore');
        }
    }

    const clickMenuDataForStore: ItemsListMenuDto = {
        setOpen: setOpenMenuForStore,
        prevOpen: prevOpen,
        open: openMenuForStore,
        anchorRef: menuRef,
        menuList: MENU_LIST_STORE_ITEMS
    }

    let settingsForPopup = getSettingsForPopup(popupSettings);

    return (
        <>
            <div className="settings_control" ref={ref}>
                <Box sx={{display: `flex`, gap: `16px`, alignItems: "center"}}>
                    <Button
                        ref={menuRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        disabled={isUserViewer}
                        onClick={handleToggleStoreMenu}
                        sx={{
                            ':disabled > svg': {
                                opacity: isUserViewer ? "0.3" : "1"
                            }
                        }}
                    >
                        <PlusIcon/>
                    </Button>
                    <ClickMenu list={clickMenuDataForStore}/>
                    <Button
                        disabled={!accountSetting?.supportedFeatures?.isStore}
                        onClick={openStore}
                        className={classes.openStoreBtn}
                    >
                        <Typography color={`#ffffff`}>
                            {"Store >"}
                        </Typography>
                    </Button>
                    <Box sx={{position: `relative`, display: "flex"}}>
                        <Button
                            className={classes.analyticsButton}
                            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                setShowAnalyticsPopup(!showAnalyticsPopup);
                                handleClick(event);
                            }}
                            title={`Analytics`}
                            disabled={flippingFlyerState.loading}
                        >
                            <AnalyticsIcon/>
                        </Button>
                        <Popover
                            PaperProps={{
                                style: {
                                    borderRadius: `6px`
                                }
                            }}
                            sx={{
                                margin: `5px 0`,
                                borderRadius: `3px`
                            }}
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <AnalyticsPopup setShowAnalyticsPopup={setShowAnalyticsPopup} closePopup={handleClose}/>
                        </Popover>

                        {/*{*/}
                        {/*    showAnalyticsPopup &&*/}
                        {/*    <AnalyticsPopup setShowAnalyticsPopup={setShowAnalyticsPopup}/>*/}
                        {/*}*/}
                    </Box>
                    <Box sx={{display: "flex", cursor: isUserViewer ? "default" : "pointer", opacity: isUserViewer || isUserEditor ? "0.3" : "1"}} onClick={() => {
                        if(!isUserViewer && !isUserEditor){
                            setShowSettingsMenu(true)
                        }
                    }} title={`Settings`}>
                        <SettingIcon/>
                        <SettingsControlsMenu
                            // show={true}
                            show={showSettingsMenu}
                            target={ref}
                            onHide={() => {
                                setShowSettingsMenu(false)
                            }}
                            showAccountLocalSettings={() => {
                                setShowStoreSettingsMenu(false);
                                setShowSettingsMenu(false);
                                setShowAnalyticsPopup(false);
                                setShowFlyerClassesPopup(false);
                                toggleSaleTypesPopup(false);
                                toggleCheckoutSettingsPopup(false);
                                setShowGuiThemesPopup(false);
                                toggleEmailsSettingsPopup(false);
                                toggleUsersAndPermissionsPopup(false);
                                setShowAccountLocalSettingPopup(true);

                            }}
                            showGuiThemeSettings={() => {
                                setShowStoreSettingsMenu(false);
                                setShowSettingsMenu(false);
                                setShowAnalyticsPopup(false);
                                setShowAccountLocalSettingPopup(false);
                                setShowFlyerClassesPopup(false);
                                toggleSaleTypesPopup(false);
                                toggleCheckoutSettingsPopup(false);
                                toggleEmailsSettingsPopup(false);
                                toggleUsersAndPermissionsPopup(false);
                                setShowGuiThemesPopup(true);
                            }}
                            showCheckoutSettings={() => {
                                setShowStoreSettingsMenu(false);
                                setShowSettingsMenu(false);
                                setShowAnalyticsPopup(false);
                                setShowAccountLocalSettingPopup(false);
                                setShowGuiThemesPopup(false);
                                setShowFlyerClassesPopup(false);
                                toggleSaleTypesPopup(false);
                                toggleEmailsSettingsPopup(false);
                                toggleUsersAndPermissionsPopup(false);
                                toggleCheckoutSettingsPopup(true)

                            }}
                            showSaleTypesSettings={() => {
                                setShowStoreSettingsMenu(false);
                                setShowSettingsMenu(false);
                                setShowAnalyticsPopup(false);
                                setShowAccountLocalSettingPopup(false);
                                setShowGuiThemesPopup(false);
                                setShowFlyerClassesPopup(false);
                                toggleCheckoutSettingsPopup(false);
                                toggleUsersAndPermissionsPopup(false);
                                toggleSaleTypesPopup(true);
                            }}
                            showFlyerClassesPopup={() => {
                                setShowStoreSettingsMenu(false);
                                setShowSettingsMenu(false);
                                toggleSaleTypesPopup(false);
                                setShowAnalyticsPopup(false);
                                setShowAccountLocalSettingPopup(false);
                                setShowGuiThemesPopup(false);
                                toggleCheckoutSettingsPopup(false);
                                toggleEmailsSettingsPopup(false);
                                toggleUsersAndPermissionsPopup(false);
                                setShowFlyerClassesPopup(true);
                            }}
                            showEmailSettingsPopup={() => {
                                setShowStoreSettingsMenu(false);
                                setShowSettingsMenu(false);
                                toggleSaleTypesPopup(false);
                                setShowAnalyticsPopup(false);
                                setShowAccountLocalSettingPopup(false);
                                setShowGuiThemesPopup(false);
                                toggleCheckoutSettingsPopup(false);
                                setShowFlyerClassesPopup(false);
                                toggleUsersAndPermissionsPopup(false);
                                toggleEmailsSettingsPopup(true);
                            }}
                            showStoreSettingsPopup={() => {
                                setShowSettingsMenu(false);
                                toggleSaleTypesPopup(false);
                                setShowAnalyticsPopup(false);
                                setShowAccountLocalSettingPopup(false);
                                setShowGuiThemesPopup(false);
                                toggleCheckoutSettingsPopup(false);
                                setShowFlyerClassesPopup(false);
                                toggleEmailsSettingsPopup(false);
                                toggleUsersAndPermissionsPopup(false);
                                setShowStoreSettingsMenu(true);
                            }}
                            showUsersAndPermissionsPopup={() => {
                                setShowSettingsMenu(false);
                                toggleSaleTypesPopup(false);
                                setShowAnalyticsPopup(false);
                                setShowAccountLocalSettingPopup(false);
                                setShowGuiThemesPopup(false);
                                toggleCheckoutSettingsPopup(false);
                                setShowFlyerClassesPopup(false);
                                toggleEmailsSettingsPopup(false);
                                setShowStoreSettingsMenu(false);
                                toggleUsersAndPermissionsPopup(true);
                            }}
                        />
                    </Box>
                </Box>

            </div>
            <AccountLocalAndTextSettingModal
                isShow={showAccountLocalSettingPopup}
                closePopup={() => setShowAccountLocalSettingPopup(false)}
                settingForAccount={true}
            />
            <CheckoutSettingPopup
                isShow={showCheckoutSettingsPopup}
                closePopup={() => toggleCheckoutSettingsPopup(false)}
                settingForAccount={true}
            />
            <SaleTypesSettings
                isShow={showSaleTypesPopup}
                onHide={() => toggleSaleTypesPopup(false)}
            />
            <GuiThemesPopup
                show={showGuiThemesPopup}
                onHide={() => setShowGuiThemesPopup(false)}
            />
            <FlyerClassesPopup
                show={showFlyerClassesPopup}
                onHide={() => setShowFlyerClassesPopup(false)}
            />

            <AccountEmailSettingPopup
                show={showEmailsSettingsPopup}
                onHide={() => toggleEmailsSettingsPopup(false)}
            />
            {
                showStoreSettingsMenu &&
                <StoreSettingsPopup
                    onHide={() => setShowStoreSettingsMenu(false)}
                />
            }
            {
                showUsersAndPermissionsPopup &&
                <UsersAndPermissionPopup
                    onHide={() => toggleUsersAndPermissionsPopup(false)}
                />
            }

            {
                isLoading &&
                <div className={styles.isLoading}>
                    <PageSpinner/>
                </div>
            }

            {isModalPopup && <StatusPopup
                settings={settingsForPopup}
                type={settingsForPopup.typeStatus ? settingsForPopup.typeStatus : StatusPopupType.CONFIRM}
                title={settingsForPopup.title ? settingsForPopup.title : 'SUCCESS'}
                subTitle={''}
                messages={settingsForPopup.messages}
                show={isModalPopup}
                handleClose={() => setModalPopup(false)}
            />
            }

        </>
    )
}

export default SettingsControls;